import { z } from "zod";

export const DurationIconSchema = z.enum(["repetitions", "timer"]);
export type DurationIcon = z.infer<typeof DurationIconSchema>;
export const DurationUnitSchema = z.enum(["minutes", "repetitions", "repetitions_twice", "seconds", "steps"]);
export type DurationUnit = z.infer<typeof DurationUnitSchema>;

export const EquipmentSchema = z.enum([
  "backpack",
  "chair",
  "exercise_ball",
  "foamroller",
  "mobility_aid",
  "pool",
  "resistance_band",
  "sling",
  "stair",
  "stick",
  "towel",
  "water_bottles",
  "weight",
]);
export type Equipment = z.infer<typeof EquipmentSchema>;

export const LocaleSchema = z.enum(["en-gb", "en-se", "en-us", "sv-gb", "sv-se", "sv-us"]);
export type Locale = z.infer<typeof LocaleSchema>;

export const MovementSchema = z.enum([
  "abduction",
  "adduction",
  "extension",
  "external_rotation",
  "flexion",
  "internal_rotation",
  "lateral_flexion",
]);
export type Movement = z.infer<typeof MovementSchema>;

export const PositionSchema = z.enum(["lying", "sitting", "standing"]);
export type Position = z.infer<typeof PositionSchema>;

export const PrimaryFunctionSchema = z.enum(["balance", "mobility", "strength"]);
export type PrimaryFunction = z.infer<typeof PrimaryFunctionSchema>;

export const StateSchema = z.enum(["draft", "in_review", "approved", "rejected"]);

export const TargetJointsSchema = z.enum([
  "chest",
  "elbow",
  "fall_prevention",
  "foot",
  "hand",
  "hip",
  "jaw",
  "knee",
  "lower_back",
  "lower_leg",
  "neck",
  "neuro",
  "osteoporosis",
  "pelvic_floor",
  "shoulder",
  "upper_back",
  "wrist",
]);
export type TargetJoints = z.infer<typeof TargetJointsSchema>;

export const VisibilitySchema = z.enum(["private", "public"]);
